import { APPLICATION_BREAKPOINTS } from '@marriott/mi-ui-library';

import { Viewport } from './CNAnimatedBanner.types';

export const resolveInitialViewport = (): Viewport => {
  if (typeof window === 'undefined') {
    return 'desktop'; // SSR-safe fallback
  }

  const width = window.innerWidth;

  if (width >= APPLICATION_BREAKPOINTS['viewportL']) return 'desktop';
  if (width >= APPLICATION_BREAKPOINTS['viewportM']) return 'tablet';
  return 'mobile';
};
